import React from 'react'

import { func } from 'prop-types'

function Resend({ onResend }) {
  return (
    <p className="ai-sign-in-modal__resend cgt-body-base">
      Didn&apos;t receive the email?
      {' '}
      <button
        type="button"
        className="ai-sign-in-modal__switch-link cgt-link-primary-accented"
        onClick={onResend}
      >
        Click to resend
      </button>
    </p>
  )
}

Resend.propTypes = {
  onResend: func.isRequired,
}

export default Resend
